import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { analytics } from '@/reducers/AnalyticsReducer';
import { clientRfpCount } from '@/reducers/ClientRfpCountReducer';
import { clientRfpNegotiateOne } from '@/reducers/ClientRfpNegotiateOneReducer';
import { professionalRfpNegotiate } from '@/reducers/ProfessionalRfpNegotiateReducer';
import { professionalRfpOffer } from '@/reducers/RfpProOfferReducer';
import authError from './AuthErrorReducer';
import auth from './AuthReducer';
import canonical from './CanonicalReducer';
import category from './CategoryReducer';
import clientMyPage from './ClientMyPageReducer';
import clientMySolution from './ClientMySolutionReducer';
import { clientRfpNegotiateList } from './ClientRfpNegotiateListReducer';
import clientRfp from './ClientRfpReducer';
import clientSeminar from './ClientSeminarReducer';
import column from './ColumnReducer';
import comparison from './ComparisonReducer';
import demoSolution from './DemoSolutionReducer';
import document from './DocumentReducer';
import fetch from './FetchReducer';
import file from './FileReducer';
import finalForm from './FinalFormReducer';
import jsonLd from './JsonLdReducer';
import maintenance from './MaintenanceReducer';
import modal from './ModalReducer';
import news from './NewsReducer';
import notification from './NotificationReducer';
import oneSolution from './OneSolutionReducer';
import popup from './PopupReducer';
import professionalMySolution from './ProfessionalMySolutionReducer';
import professionalMySolutionRfp from './ProfessionalMySolutionRfpReducer';
import professional from './ProfessionalReducer';
import { professionalRfpQuestion } from './ProfessionalRfpQuestionReducer';
import { professionalRfp } from './ProfessionalRfpReducer';
import professionalSeminar from './ProfessionalSeminarReducer';
import professionalSolution from './ProfessionalSolutionReducer';
import professionalUnit from './ProfessionalUnitReducer';
import proffitSearchDevice from './ProffitSearchDeviceReducer';
import proffitSearchGroup from './ProffitSearchGroupReducer';
import proffitSearchHeader from './ProffitSearchHeaderReducer';
import proffitSearchInformationTop from './ProffitSearchInformationTopReducer';
import proffitSearchReceiveHeader from './ProffitSearchReceiveHeaderReducer';
import proffitSearchReceive from './ProffitSearchReceiveReducer';
import proffitSearch from './ProffitSearchReducer';
import proffitSearchShareHeader from './ProffitSearchShareHeaderReducer';
import proffitSearchShare from './ProffitSearchShareReducer';
import proffitSearchSlide from './ProffitSearchSlideReducer';
import profile from './ProfileReducer';
import searchSolution from './SearchSolutionReducer';
import toast from './ToastReducer';
export default combineReducers({
    analytics,
    auth,
    authError,
    canonical,
    category,
    clientMyPage,
    clientMySolution,
    clientRfp,
    clientRfpCount,
    clientRfpNegotiateList,
    clientRfpNegotiateOne,
    clientSeminar,
    column,
    comparison,
    demoSolution,
    document,
    fetch,
    file,
    finalForm,
    form,
    jsonLd,
    maintenance,
    modal,
    news,
    notification,
    oneSolution,
    popup,
    professional,
    professionalMySolution,
    professionalMySolutionRfp,
    professionalRfp,
    professionalRfpNegotiate,
    professionalRfpOffer,
    professionalRfpQuestion,
    professionalSeminar,
    professionalSolution,
    professionalUnit,
    proffitSearch,
    proffitSearchDevice,
    proffitSearchGroup,
    proffitSearchHeader,
    proffitSearchInformationTop,
    proffitSearchReceive,
    proffitSearchReceiveHeader,
    proffitSearchShare,
    proffitSearchShareHeader,
    proffitSearchSlide,
    profile,
    searchSolution,
    toast,
});
